<template>
  <div class="password">
    <b-button
      v-if="showBack"
      class="back-button"
      type="is-text"
      icon-left="arrow-left"
      size="is-medium"
      @click="$router.back()"
    ></b-button>
    <span class="wrong-password" v-if="tries > 1">{{
      $t("password.wrongPassword")
    }}</span>
    <b-field
      :label="$t('password.enterPassword')"
      :type="{ 'is-danger': errors.has('password') }"
      :message="errors.first('password')"
    >
      <b-field grouped>
        <b-input
          :placeholder="`${$t('password.name')}...`"
          expanded
          name="password"
          v-model="password"
          @keyup.native="savePassword($event)"
          password-reveal
          v-validate="'required'"
        ></b-input>
        <p class="control">
          <b-button
            @click.stop.prevent="savePassword($event)"
            class="button is-info"
          >
            {{ $t("save.name") }}
          </b-button>
        </p>
      </b-field>
    </b-field>
  </div>
</template>

<script>
export default {
  name: "password",
  props: {
    tries: {
      default: 0,
      type: Number
    },
    showBack: {
      default: false,
      type: Boolean
    }
  },
  data: () => {
    return {
      password: ""
    };
  },
  methods: {
    savePassword(e) {
      if (e.key === "Enter" || event.type === "click") {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$emit("save", this.password);
          }
        });
      }
    }
  }
};
</script>
